export default "assets/images/icons/tel-2196f31d.svg";